import { render, staticRenderFns } from "./CarDestPage.vue?vue&type=template&id=3b7a1ab9&scoped=true"
import script from "./CarDestPage.js?vue&type=script&lang=js&external"
export * from "./CarDestPage.js?vue&type=script&lang=js&external"
import style0 from "./CarDestPage.vue?vue&type=style&index=0&id=3b7a1ab9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7a1ab9",
  null
  
)

export default component.exports